import React from 'react'
import Img from 'gatsby-image'

const ImageModal = ({ showImage, hide, photo }) => {

    if (!showImage) {
        return null;
    }

    return (
        <div className="overlay lightbox" onClick={hide}>
            <div className="image">
                <Img
                    fluid={photo?.localFile?.childImageSharp?.fluid}
                />
            </div>
        </div>
    )
}

export default ImageModal
